// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ActiveFiltersController from "./active_filters_controller"
application.register("active-filters", ActiveFiltersController)

import AreaPickerController from "./area_picker_controller"
application.register("area-picker", AreaPickerController)

import AutoAdvanceController from "./auto_advance_controller"
application.register("auto-advance", AutoAdvanceController)

import BeltPickerController from "./belt_picker_controller"
application.register("belt-picker", BeltPickerController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import ChannelFilterController from "./channel_filter_controller"
application.register("channel-filter", ChannelFilterController)

import ChapterNavigationController from "./chapter_navigation_controller"
application.register("chapter-navigation", ChapterNavigationController)

import ClearSearchController from "./clear_search_controller"
application.register("clear-search", ClearSearchController)

import CountInModalController from "./count_in_modal_controller"
application.register("count-in-modal", CountInModalController)

import CourseOverviewController from "./course_overview_controller"
application.register("course-overview", CourseOverviewController)

import CurrentLessonIntroController from "./current_lesson_intro_controller"
application.register("current-lesson-intro", CurrentLessonIntroController)

import FiveSecondTestController from "./five_second_test_controller"
application.register("five-second-test", FiveSecondTestController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import InstructorReconciliationController from "./instructor_reconciliation_controller"
application.register("instructor-reconciliation", InstructorReconciliationController)

import FacetCountsController from "./facet_counts_controller"
application.register("facet-counts", FacetCountsController)

import LessonActionsController from "./lesson_actions_controller"
application.register("lesson-actions", LessonActionsController)

import LessonGroupController from "./lesson_group_controller"
application.register("lesson-group", LessonGroupController)

import LessonInterstitialController from "./lesson_interstitial_controller"
application.register("lesson-interstitial", LessonInterstitialController)

import LessonIntroController from "./lesson_intro_controller"
application.register("lesson-intro", LessonIntroController)

import MobileSearchClearController from "./mobile_search_clear_controller"
application.register("mobile-search-clear", MobileSearchClearController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ModalFiltersController from "./modal_filters_controller"
application.register("modal-filters", ModalFiltersController)

import ModalScreensController from "./modal_screens_controller"
application.register("modal-screens", ModalScreensController)

import NamesController from "./names_controller"
application.register("names", NamesController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import OpenModalFiltersController from "./open_modal_filters_controller"
application.register("open-modal-filters", OpenModalFiltersController)

import OtpInputController from "./otp_input_controller"
application.register("otp-input", OtpInputController)

import PlayerController from "./player_controller"
application.register("player", PlayerController)

import PlayerTabsController from "./player_tabs_controller"
application.register("player-tabs", PlayerTabsController)

import PractitionerSuggestionsController from "./practitioner_suggestions_controller"
application.register("practitioner-suggestions", PractitionerSuggestionsController)

import ProfessorModeController from "./professor_mode_controller"
application.register("professor-mode", ProfessorModeController)

import ProfileSettingsController from "./profile_settings_controller"
application.register("profile-settings", ProfileSettingsController)

import RadioSubmitController from "./radio_submit_controller"
application.register("radio-submit", RadioSubmitController)

import RegistrationController from "./registration_controller"
application.register("registration", RegistrationController)

import RevealPlayerController from "./reveal_player_controller"
application.register("reveal-player", RevealPlayerController)

import SchoolSearchController from "./school_search_controller"
application.register("school-search", SchoolSearchController)

import ScrollIntoViewController from "./scroll_into_view_controller"
application.register("scroll-into-view", ScrollIntoViewController)

import ScrollLockController from "./scroll_lock_controller"
application.register("scroll-lock", ScrollLockController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SearchModalLoaderController from "./search_modal_loader_controller"
application.register("search-modal-loader", SearchModalLoaderController)

import SegmentPlayerController from "./segment_player_controller"
application.register("segment-player", SegmentPlayerController)

import SignupDisabledController from "./signup_disabled_controller"
application.register("signup-disabled", SignupDisabledController)

import SlideToggleController from "./slide_toggle_controller"
application.register("slide-toggle", SlideToggleController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import TabBarController from "./tab_bar_controller"
application.register("tab-bar", TabBarController)

import SpeedPopoverController from "./speed_popover_controller"
application.register("speed-popover", SpeedPopoverController)

import SourceVideoModalController from "./source_video_modal_controller"
application.register("source-video-modal", SourceVideoModalController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import TrackingController from "./tracking_controller"
application.register("tracking", TrackingController)

import TrainingSessionListController from "./training_session_list_controller"
application.register("training-session-list", TrainingSessionListController)

import VideoPlayerController from "./video_player_controller"
application.register("video-player", VideoPlayerController)

import VideoPopoverController from "./video_popover_controller"
application.register("video-popover", VideoPopoverController)

import WorkItemController from "./work_item_controller"
application.register("work-item", WorkItemController)

import WorkQueueController from "./work_queue_controller"
application.register("work-queue", WorkQueueController)
